import { render, staticRenderFns } from "./lookJson.vue?vue&type=template&id=382a71a1&scoped=true&"
import script from "./lookJson.vue?vue&type=script&lang=js&"
export * from "./lookJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382a71a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('382a71a1')) {
      api.createRecord('382a71a1', component.options)
    } else {
      api.reload('382a71a1', component.options)
    }
    module.hot.accept("./lookJson.vue?vue&type=template&id=382a71a1&scoped=true&", function () {
      api.rerender('382a71a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/risk/dialogs/lookJson.vue"
export default component.exports